/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import PortalIdParser from 'PortalIdParser';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButton from 'UIComponents/button/UIButton';
import UsageTracker from '../../utils/UsageTracker';
import { getIsEnrolledInGettingStarted } from '../../actions/GettingStartedActions';
import { FormattedReactMessage } from 'LearningCenterUI/components/I18n';
import H5 from 'UIComponents/elements/headings/H5';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { getAcademyToSoftwareShowTooltip } from '../../selectors/academyToSoftwareSelectors';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import { hideTooltip } from '../../actions/AcademyToSoftware';
import { useHomepageUrl } from '../../features/navigation';
import { useIsPaidAccount } from '../../hooks/productsHooks';
import { LORAX } from 'HubStyleTokens/colors';
import HubSpotLogo from '../../components/Icons/HubSpotLogo';
import UILink from 'UIComponents/link/UILink';
import { SkeletonBlock, SkeletonWrapper } from '../../components/Skeleton';
import SafeStorage from 'SafeStorage';
import { UserAttributeKeys, useUserAttribute } from '../../features/userAttributes';
import styled, { mediaQuery, css } from '../../utils/Styling';
export const PositionedUIButton = styled(UIButton).withConfig({
  displayName: "SoftwareDesirabilityButton__PositionedUIButton",
  componentId: "sc-1vywhnd-0"
})(["top:5px;right:20px;width:max-content;display:inline-block !important;padding:4px 16px !important;min-height:36px;", ""], mediaQuery('mobileNavbar', css(["display:none !important;"])));
const PlayIcon = styled(props => /*#__PURE__*/_jsx("div", Object.assign({}, props, {
  children: /*#__PURE__*/_jsx(UIIcon, {
    className: "inner-icon",
    color: "OLAF",
    name: "playerPlay",
    size: 18
  })
}))).withConfig({
  displayName: "SoftwareDesirabilityButton__PlayIcon",
  componentId: "sc-1vywhnd-1"
})(["height:26px;width:26px;border-radius:50%;background-color:", ";display:flex;align-items:center;justify-content:center;.inner-icon{margin-top:3px;margin-left:2px;}"], LORAX);

const PlainButton = props => /*#__PURE__*/_jsx("div", Object.assign({
  role: "button"
}, props));

const ButtonHeading = styled(H5).withConfig({
  displayName: "SoftwareDesirabilityButton__ButtonHeading",
  componentId: "sc-1vywhnd-2"
})(["font-size:14px;"]);
const SmallHubSpotLogo = styled(HubSpotLogo).withConfig({
  displayName: "SoftwareDesirabilityButton__SmallHubSpotLogo",
  componentId: "sc-1vywhnd-3"
})(["font-size:16px;"]);

const SoftwareDesirabilityButton = ({
  isEnrolled,
  isEnrolledRequesting,
  isEnrolledFetchedOnce,
  setModalOpen,
  showTooltip,
  use
}) => {
  const {
    homepage: homepageUrl
  } = useHomepageUrl();
  const [isPaidAccount, isPaidAccountRequesting] = useIsPaidAccount();
  const dispatch = useDispatch();
  const isLoading = isPaidAccountRequesting || !isPaidAccount && isEnrolledRequesting;
  const localItem = SafeStorage.getItem('force_is_enrolled_in_user_guide');
  const enrollLocalOverride = localItem !== null ? JSON.parse(localItem) : null;
  const isEnrolledOverridable = enrollLocalOverride !== null ? enrollLocalOverride : isEnrolled;
  const isEnrolledOrPaidWithHomepageOverridable = enrollLocalOverride !== null ? enrollLocalOverride : isEnrolled || isPaidAccount && !!homepageUrl;
  const {
    setUserAttribute: setHasSeenCloseTooltip
  } = useUserAttribute(UserAttributeKeys.HAS_SEEN_CLOSE_TOOLTIP);
  useEffect(() => {
    if (!isEnrolledFetchedOnce) {
      dispatch(getIsEnrolledInGettingStarted());
    }
  }, [dispatch, isEnrolledFetchedOnce]);

  const onClick = () => {
    if (isPaidAccount && homepageUrl) {
      window.open(homepageUrl, '_blank');
    } else if (isEnrolledOverridable) {
      window.open(`/user-guide/${PortalIdParser.getPortalIdFromPath()}`, '_blank');
    } else {
      setModalOpen(true);
    }

    UsageTracker.track('interaction', {
      action: 'academy-to-software-button-clicked',
      isEnrolledOverridable,
      isPaidAccount,
      homepageUrl,
      buttonStyle: use,
      whichButton: 'cta'
    });
  };

  useEffect(() => {
    if (!isLoading) {
      UsageTracker.track('interaction', {
        action: 'academy-to-software-button-viewed',
        isEnrolledOverridable,
        isPaidAccount,
        homepageUrl,
        buttonStyle: use,
        whichButton: 'cta'
      });
    }
  }, [homepageUrl, isEnrolledOverridable, isLoading, isPaidAccount, use]);
  const ButtonComponent = use === 'button' ? PositionedUIButton : PlainButton;
  return /*#__PURE__*/_jsx(UIPopover, {
    open: showTooltip,
    placement: "bottom left",
    renderContent: () => {
      return /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        style: {
          padding: '10px 18px',
          lineHeight: '18px'
        },
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "academyNav.softwareDesirability.tooltip"
        }), /*#__PURE__*/_jsx(UIButton, {
          className: "m-top-2",
          onClick: () => {
            dispatch(hideTooltip());
            setHasSeenCloseTooltip(true);
            UsageTracker.track('interaction', {
              action: 'academy-to-software-tooltip-dismissed'
            });
          },
          size: "sm",
          use: "tertiary-light",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyNav.softwareDesirability.gotItButton"
          })
        })]
      });
    },
    use: "tooltip",
    width: 320,
    children: /*#__PURE__*/_jsxs(ButtonComponent, {
      "data-is-enrolled": isEnrolledOverridable,
      "data-is-enrolled-or-paid-with-homepage": isEnrolledOrPaidWithHomepageOverridable,
      "data-is-paid": isPaidAccount,
      "data-test-id": "academy-to-software-desirability-button",
      onClick: onClick,
      size: "sm",
      style: use === 'inline-link' ? {
        display: 'inline-block'
      } : {},
      use: "secondary-ghost",
      children: [use === 'inline-link' ? /*#__PURE__*/_jsx(SkeletonWrapper, {
        style: {
          marginBottom: '-2px',
          height: 14,
          width: 100,
          display: isLoading ? 'block' : 'none',
          opacity: 0.2
        },
        children: /*#__PURE__*/_jsx(SkeletonBlock, {
          style: {
            height: 14,
            width: '100%'
          }
        })
      }) : /*#__PURE__*/_jsx(UILoadingSpinner, {
        layout: "inline",
        size: "extra-small",
        style: {
          margin: '-3px 20px',
          display: isLoading ? 'block' : 'none'
        }
      }), /*#__PURE__*/_jsxs(UIFlex, {
        align: isEnrolledOrPaidWithHomepageOverridable ? 'baseline' : 'center',
        style: {
          display: !isLoading ? 'flex' : 'none'
        },
        children: [use === 'inline-link' ? /*#__PURE__*/_jsx(UILink, {
          className: "m-bottom-0",
          use: "on-dark",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `academyNav.softwareDesirability.inlineLink.${isEnrolledOrPaidWithHomepageOverridable ? 'enrolled' : 'notEnrolled'}`
          })
        }) : /*#__PURE__*/_jsx(ButtonHeading, {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: `academyNav.softwareDesirability.button.${isEnrolledOrPaidWithHomepageOverridable ? 'enrolled' : 'notEnrolled'}`,
            options: {
              hubspotTextLogo: /*#__PURE__*/_jsx(SmallHubSpotLogo, {})
            }
          })
        }), isEnrolledOrPaidWithHomepageOverridable && /*#__PURE__*/_jsx(UIIcon, {
          className: "m-left-1",
          name: "externalLink"
        }), !isEnrolledOrPaidWithHomepageOverridable && use !== 'inline-link' && /*#__PURE__*/_jsx(PlayIcon, {
          className: use === 'button' ? 'm-left-4' : 'm-left-2'
        })]
      })]
    })
  });
};

SoftwareDesirabilityButton.propTypes = {
  isEnrolled: PropTypes.bool,
  isEnrolledFetchedOnce: PropTypes.bool,
  isEnrolledRequesting: PropTypes.bool,
  setModalOpen: PropTypes.func.isRequired,
  showTooltip: PropTypes.bool,
  use: PropTypes.oneOf(['button', 'inline', 'inline-link'])
};
SoftwareDesirabilityButton.defaultProps = {
  use: 'button'
};

const mapStateToProps = state => ({
  isEnrolled: state.gettingStarted.isEnrolledInGettingStarted,
  isEnrolledRequesting: state.gettingStarted.isGetIsEnrolledRequesting,
  isEnrolledFetchedOnce: state.gettingStarted.hasFetchedOnce,
  showTooltip: getAcademyToSoftwareShowTooltip(state)
});

export default connect(mapStateToProps)(SoftwareDesirabilityButton);